export default __webpack_public_path__ + "static/media/NotoSansJP-Regular.30ac0ac1.otf";